export const appVersion = "v1.0.2"
export const stagingVersion = "v1.0.4-staging"

export function getAppVersion() {
   return window.location.host === "exam.workersbadge.com"
      ? appVersion
      : stagingVersion
}
